import React, { createContext, useContext, useState, useEffect } from 'react';
import { useAuthToken } from './AuthTokenContext';

const AuthRouteContext = createContext();

export function AuthRouteProvider({ children }) {
  const { token } = useAuthToken();
  const [redirectPathAfterLogin, setRedirectPathAfterLogin] = useState(null);

  const requireAuth = (action, redirectCallback) => {
    if (token) {
      action();
    } else {
      setRedirectPathAfterLogin(window.location.pathname);
      if (redirectCallback) {
        redirectCallback();
      }
    }
  };

  return (
    <AuthRouteContext.Provider
      value={{
        requireAuth,
        setRedirectPathAfterLogin,
        redirectPathAfterLogin
      }}
    >
      {children}
    </AuthRouteContext.Provider>
  );
}

export function useAuthRouting() {
  return useContext(AuthRouteContext);
}
